import _extends from '@babel/runtime/helpers/extends';
import { px2rem } from '../utils/helpers/style.js';
import { colors } from '../constants/colors.js';

var tabsAttributesNative = {
  color: 'primary',
  border: colors.cloudGrey,
  background: 'background',
  textColor: 'text',
  height: 56,
  fontSize: {
    "default": 'M',
    XS: 16,
    S: 18,
    L: 23,
    M: 20
  },
  navButton: {
    paddingLeftRight: 32,
    selected: {
      border: {
        width: 4
      }
    },
    unselected: {
      textColor: colors.octoberGrey,
      border: {
        width: 0
      }
    }
  }
};
var tabsThemeNative = _extends({}, tabsAttributesNative, {
  variants: {
    condensed: {
      fontSize: {
        "default": 'XS'
      },
      height: 40,
      navButton: {
        paddingLeftRight: 16,
        selected: {
          border: {
            width: 2
          }
        }
      }
    }
  }
});
var tabsAttributesWeb = {
  color: 'primary',
  background: 'background',

  /**
   * Gap between the tabs
   */
  gap: 0,
  textColor: 'text',
  borders: {
    radius: 'borders.radius',
    color: colors.cloudGrey
  },

  /**
   * Tab button heights
   */
  height: {
    /**
     * Below breakpoint s
     */
    "default": px2rem(48),

    /**
     * At breakpoint s and above
     */
    s: px2rem(56)
  },
  fontSize: {
    "default": 'M',
    base: px2rem(18),
    XS: 16,
    S: 18,
    M: 20,
    L: 23
  },
  inactive: {
    background: 'transparent'
  },
  active: {
    mode: 'underline',
    focusHighlight: 'lighten'
  },
  selectedBorderWidth: px2rem(4)
};
var tabsThemeWeb = _extends({}, tabsAttributesWeb, {
  variants: {
    condensed: {
      fontSize: {
        base: px2rem(16),
        "default": 'XS'
      },
      height: {
        /**
         * Below breakpoint s
         */
        "default": px2rem(40),

        /**
         * At breakpoint s and above
         */
        s: px2rem(40)
      },
      selectedBorderWidth: px2rem(2)
    }
  }
});
var tabsDarkThemeWeb = _extends({}, tabsThemeWeb, {
  borders: _extends({}, tabsThemeWeb.borders, {
    color: colors.mineShaftGrey
  })
});

export { tabsAttributesNative, tabsAttributesWeb, tabsDarkThemeWeb, tabsThemeNative, tabsThemeWeb };
